import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  bottomSheet: {
    borderTopLeftRadius: theme.borderRadius.s,
    borderTopRightRadius: theme.borderRadius.s,
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  iframe: {
    width: '100%',
    height: '100%',
    flex: 1,
  },
});
